module.exports = __webpack_public_path__ + "static/media/unilever.4ba587d4.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/brand-logos/unilever.png
// module id = 114
// module chunks = 0